import Card from '../../atoms/card/Card';
import Chip, { ChipType } from '../../atoms/chip/Chip';
import { PreviousClaimSummary } from '../../../domain/entities/PreviousClaimSummary';
import { useModuleTranslation } from '../../utils/useModuleTranslation';
import './previous-claim-summaries-list.modules.scss';

export type PreviousClaimSummariesListProps = {
    previousClaimSummaries: PreviousClaimSummary[];
};

const PreviousClaimSummariesList = ({ previousClaimSummaries }: PreviousClaimSummariesListProps) => {
    const { t } = useModuleTranslation();

    return (
        <Card title={t('clinical_history.previous_claims.title')} className="previous-claim-summaries-list">
            {previousClaimSummaries.length === 0 ? (
                <p className="previous-claim-summaries-list__empty">
                    {t('clinical_history.previous_claims.no_claims')}
                </p>
            ) : (
                <ul className="previous-claim-summaries-list__items">
                    {previousClaimSummaries.map((claim) => (
                        <li key={claim.claimRequestKey} className="previous-claim-summaries-list__item">
                            <div className="previous-claim-summaries-list__header">
                                <span className="previous-claim-summaries-list__date">
                                    {claim.createdAt.toLocaleDateString()}
                                </span>
                                <Chip text={claim.status} type={ChipType.NEUTRAL} />
                            </div>
                            {claim.summary ? (
                                <p className="previous-claim-summaries-list__summary">{claim.summary}</p>
                            ) : (
                                <p className="previous-claim-summaries-list__summary previous-claim-summaries-list__summary--empty">
                                    {t('clinical_history.previous_claims.no_summary')}
                                </p>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </Card>
    );
};

export default PreviousClaimSummariesList;
